module.exports = __webpack_public_path__ + "img/industry5.7f556f24.png";